import * as React from 'react';

import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import { Routes, Route, Link, NavLink } from "react-router-dom";

import Timesheets from "./components/Timesheets/Timesheets";
import Timesheet from "./components/Timesheet/Timesheet";
import Vacation from "./components/Vacation/Vacation";
import Absence from "./components/Absence/Absence";
import Help from "./components/Help/Help";
import About from "./components/About/About";

import Loading from "./components/Loading/Loading";

import logo from "./components/ielogo.png";
import PersonIcon from '@mui/icons-material/Person';
import './App.css';
import axios from "axios"

export default function App() {
  let navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [username, setUsername] = React.useState("");

  const path = [
    { name: "Timesheets", link: "/timesheets" },
    { name: "Vacation Status", link: "/vacation" },
    { name: "Absence", link: "/absence" },
    { name: "Help", link: "/help" },
    { name: "About", link: "/about" },
    // { name: "Approvals", link: "/timesheets3" },
    // { name: "Send message", link: "/timesheets4" },
  ];

  React.useEffect(() => {

    axios.get("/api/username")
      .then(res => {
        if (username.length === 0 && res.headers.date) {
          if (res && res.data && res.data !== username) {
            if (res.data.csrfToken) {
              localStorage.setItem('csrfToken', res.data.csrfToken);
            }
            setUsername(res.data.username)
            axios.interceptors.request.use(function (config) {
              // Do something before request is sent
              config.headers["csrfToken"] = `${localStorage.getItem("csrfToken")}`;
              return config;
            }, function (error) {
              // Do something with request error
              return Promise.reject(error);
            });

          }
        }
        else {
          window.location.href = "/login";
        }
      })
      .catch(err => {
        console.log(err)
        window.location.href = "/login";
      });
  }, [])

  return (
    <>
      <div>
        <AppBar position="static" style={{ backgroundColor: "#ac0533", width: "100%" }}>
          <Toolbar>
            <a href="/"><img src={logo} width={32} style={{ marginRight: 10 }} /></a>
            <Typography variant="h6" sx={{ flexGrow: 1, color: "white", textDecoration: "none" }} component={Link} to={'/'}>
              deCODE Activities
            </Typography>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              // sx={{ mr: 2 }}
              onClick={() => setOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <SwipeableDrawer
          anchor={"right"}
          open={open}
          PaperProps={{
            sx: { width: "70%" },
          }}
          onClose={() => open ? setOpen(false) : null}
          onOpen={() => open ? null : setOpen(true)}
        >
          <div>
            <List disablePadding>
              <ListItem
                divider
                button
                // onClick={() => { window.location.href = '/logout'; }}
                style={{ backgroundColor: "rgb(172, 5, 51)", color: "white" }}
              ><PersonIcon />
                <ListItemText disableTypography style={{ fontWeight: "600" }}>{username}</ListItemText>
              </ListItem>
              {path.map(({ name, link }) => (
                <ListItem
                  key={link}
                  divider
                  button
                  onClick={() => {
                    setOpen(false);
                    navigate(link, { replace: false })
                  }}
                >
                  <ListItemText disableTypography>
                    <NavLink style={({ isActive }) => {
                      return {
                        // display: "block",
                        // margin: "1rem 0",
                        textDecoration: "none",
                        color: isActive ? "rgb(172, 5, 51)" : "black",
                        fontWeight: isActive ? "bold" : "initial"
                      };
                    }} to={link}>

                      {name}
                    </NavLink>
                  </ListItemText>
                </ListItem>
              ))}
              <ListItem
                divider
                button
                onClick={() => { window.location.href = '/logout'; }}
              >
                <ListItemText disableTypography>Log Out</ListItemText>
              </ListItem>
            </List>
          </div>

        </SwipeableDrawer>
      </div>
      <div className="App">
        {username && (
          <Routes>
            <Route path="/" element={<Timesheets />} />
            <Route path="/timesheets" element={<Timesheets />} />
            <Route path="/timesheet" element={<Timesheet />} />
            <Route path="/vacation" element={<Vacation />} />
            <Route path="/absence" element={<Absence />} />
            <Route path="/about" element={<About />} />
            <Route path="/help" element={<Help />} />
            {/* 404 component here */}
            <Route path="*" element={<Timesheets />} />
          </Routes>
        )}
        {!username && (
          <Loading />
        )}
      </div>
    </>
  );
}

axios.interceptors.response.use(function (response) {
  if (response && response.headers && response.request && response.request.responseURL &&
    response.headers['content-type'].includes('text/html') && response.request.responseURL.includes('https://login.decode.')) {
    window.location = "/login";
  } else {
    return response
  }
}, function (error) {
  if (error.response.status === 401) {
    window.location = "/logout";
  }
  return Promise.reject(error.response.data)
}) 